import { useReveal } from "../../../../hooks/useReveal";
import styles from "./TalentsTestimonial.module.css";

export default function TalentsTestimonial() {
  const { ref, isVisible } = useReveal();

  return (
    <section className={styles.section} id="stories">
      <div className={styles.container}>
        <div
          ref={ref}
          className={`${styles.card} ${isVisible ? styles.visible : styles.hidden}`}
        >
          {/* Floating quote mark */}
          <div className={styles.quoteMark} aria-hidden="true">
            "
          </div>

          <div className={styles.stars} aria-label="5 stars">
            ★★★★★
          </div>

          <p className={styles.quoteText}>
            The Awasource system of connecting talent with a client was key in
            helping me get my current UI/UX Design job. I'm really excited
            about this. Great job guys.
          </p>

          <div className={styles.author}>
            <div className={styles.avatar} aria-hidden="true">
              IA
            </div>
            <div className={styles.authorMeta}>
              <b>Ibukunoluwa Adura</b>
              <span>UI/UX Design</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
